import { Stack, styled, Typography } from '@mui/material';

import palette from '../theme/palette';

export const H2 = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: palette.black
});

export const SH2 = styled(Typography)({
  fontSize: '11px',
  color: palette.grey[400]
});

export const Row = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center'
});

export const PageTitle = styled('span')({
  fontSize: '28px',
  lineHeight: '36px',
  fontWeight: 700,
  fontStyle: 'Reddit Sans',
  color: palette.black,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px'
});
export const PageSubTitle = styled('span')({
  marginTop: '8px',
  marginBottom: '3vh',
  fontSize: '16px',
  lineHeight: '16px',
  fontWeight: 500,
  fontStyle: 'Reddit Sans',
  color: palette.grey[500]
});
